
(function () {
  'use strict';

  var RECENT_KEY = 'cw_choice_search_recent_v1';
  var CORRECTION_KEY = 'cw_choice_search_correction_v1';
  var tokenMap = {
    'wardobe': 'wardrobe',
    'wardobes': 'wardrobes',
    'wardbrobe': 'wardrobe',
    'wardbrobes': 'wardrobes',
    'wardrope': 'wardrobe',
    'wardropes': 'wardrobes',
    'wardrobs': 'wardrobes',
    'slidding': 'sliding',
    'slding': 'sliding',
    'slidingg': 'sliding',
    'mirrowed': 'mirrored',
    'mirrorred': 'mirrored',
    'mirrow': 'mirror',
    'draws': 'drawers',
    'bedisde': 'bedside',
    'bedsde': 'bedside',
    'armoire': 'wardrobe',
    'armoires': 'wardrobes',
    'closet': 'wardrobe',
    'closets': 'wardrobes'
  };
  var phraseMap = [
    [/\bchest of draws\b/gi, 'chest of drawers'],
    [/\bchester drawers\b/gi, 'chest of drawers'],
    [/\bchester draws\b/gi, 'chest of drawers'],
    [/\bbed[\s-]+side\b/gi, 'bedside'],
    [/\bsliding door wardrobe\b/gi, 'sliding wardrobe'],
    [/\bmirror wardrobe\b/gi, 'mirrored wardrobe']
  ];

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function correctQuery(value) {
    var result = clean(value);
    phraseMap.forEach(function (pair) { result = result.replace(pair[0], pair[1]); });
    result = result.split(' ').map(function (token) {
      var lower = token.toLowerCase();
      return tokenMap[lower] || token;
    }).join(' ');
    return clean(result);
  }

  function searchUrl(query) {
    return '/search?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last';
  }

  function readRecent() {
    try {
      var value = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(value) ? value.filter(Boolean).slice(0, 5) : [];
    } catch (error) {
      return [];
    }
  }

  function saveRecent(query) {
    var cleaned = clean(query);
    if (!cleaned) return;
    var next = readRecent().filter(function (item) {
      return item.toLowerCase() !== cleaned.toLowerCase();
    });
    next.unshift(cleaned);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(next.slice(0, 5))); } catch (error) {}
  }

  function emit(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function renderRecent() {
    var recent = readRecent();
    document.querySelectorAll('[data-choice-search-recent]').forEach(function (wrapper) {
      var holder = wrapper.querySelector('[data-choice-search-recent-links]');
      if (!holder || !recent.length) {
        wrapper.hidden = true;
        return;
      }
      holder.innerHTML = '';
      recent.forEach(function (query) {
        var link = document.createElement('a');
        link.href = searchUrl(query);
        link.textContent = query;
        link.setAttribute('data-choice-search-link', '');
        link.setAttribute('data-choice-search-recent-query', query);
        holder.appendChild(link);
      });
      wrapper.hidden = false;
    });
  }

  function showStoredCorrection() {
    var raw;
    try {
      raw = sessionStorage.getItem(CORRECTION_KEY);
      sessionStorage.removeItem(CORRECTION_KEY);
    } catch (error) {}
    if (!raw) return;
    try {
      var data = JSON.parse(raw);
      if (!data.original || !data.corrected || data.original === data.corrected) return;
      var notice = document.querySelector('[data-choice-search-notice]');
      if (notice) {
        notice.textContent = 'We corrected “' + data.original + '” to “' + data.corrected + '”.';
      }
    } catch (error) {}
  }

  function bindForms() {
    document.querySelectorAll('form[action*="/search"], [data-choice-search-form]').forEach(function (form) {
      if (form.dataset.choiceSearchBound === 'true') return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      form.dataset.choiceSearchBound = 'true';

      var suggestion = form.querySelector('[data-choice-search-suggestion]');

      input.addEventListener('input', function () {
        if (!suggestion) return;
        var original = clean(input.value);
        var corrected = correctQuery(original);
        if (original.length > 2 && corrected.toLowerCase() !== original.toLowerCase()) {
          suggestion.innerHTML = '';
          suggestion.appendChild(document.createTextNode('Did you mean '));
          var button = document.createElement('button');
          button.type = 'button';
          button.textContent = corrected + '?';
          button.addEventListener('click', function () {
            input.value = corrected;
            suggestion.hidden = true;
            input.focus();
          });
          suggestion.appendChild(button);
          suggestion.hidden = false;
        } else {
          suggestion.hidden = true;
        }
      });

      form.addEventListener('submit', function () {
        var original = clean(input.value);
        if (!original) return;
        var corrected = correctQuery(original);
        if (corrected && corrected.toLowerCase() !== original.toLowerCase()) {
          input.value = corrected;
          try {
            sessionStorage.setItem(CORRECTION_KEY, JSON.stringify({
              original: original,
              corrected: corrected
            }));
          } catch (error) {}
        }
        saveRecent(corrected || original);
        emit('choice_search_submit', {
          query: corrected || original,
          original_query: original,
          corrected: corrected.toLowerCase() !== original.toLowerCase()
        });
      });
    });
  }

  function bindLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-choice-search-link]');
      if (!link) return;
      var url;
      try { url = new URL(link.href, window.location.origin); } catch (error) { return; }
      var query = clean(url.searchParams.get('q'));
      if (query) saveRecent(query);
      emit('choice_search_shortcut_click', {
        query: query,
        recent: link.hasAttribute('data-choice-search-recent-query')
      });
    });
  }

  function init() {
    if (window.__cwChoiceSearchInitialized) return;
    window.__cwChoiceSearchInitialized = true;

    bindForms();
    bindLinks();
    renderRecent();
    showStoredCorrection();

    document.documentElement.classList.add('choice-search-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
